<template>
  <v-container>
    <v-row>
      <v-col>
        <v-card>
          <v-toolbar color="red accent-2" dark>
            <v-toolbar-title> انشاء زبون </v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-container>
            <v-row>
              <v-col cols="8" offset="2">
                <v-form>
                  <v-text-field
                    v-model="CustId"
                    label="رقم الزبون"
                    required
                    @keydown="checkKeyDownAlphaNumeric($event)"
                    type="number"
                    hide-spin-buttons
                  ></v-text-field>
                  <v-text-field
                    v-model="Name"
                    label="الاسم"
                    required
                    :rules="ReqRules"
                    autocomplete="off"
                  ></v-text-field>
                  <v-text-field
                    v-model="Username"
                    label="اسم المستخدم"
                    required
                    :rules="ReqRules"
                    autocomplete="new-password"
                  ></v-text-field>
                  <v-text-field
                    v-model="Password"
                    label="كلمة المرور"
                    required
                    type="password"
                    :rules="pwdRules"
                    autocomplete="new-password"
                  ></v-text-field>
                  <v-text-field
                    v-model="PasswordConfirm"
                    label="تأكيد كلمة المرور"
                    required
                    type="password"
                    :rules="pwdRules"
                    autocomplete="off"
                  ></v-text-field>
                  <b style="color: red"
                    ><div v-if="PasswordChange && UnlockRegister">
                      كلمة المرور لا تتطابق
                    </div></b
                  >
                  <v-btn
                    rounded
                    class="mt-7"
                    color="success"
                    @click="Register"
                    :disabled="UnlockRegister"
                    >انشاء</v-btn
                  >
                </v-form>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
      <v-col>
        <v-card>
          <v-toolbar color="red accent-2" dark>
            <v-toolbar-title> تحديث المواد </v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-container>
            <v-row>
              <v-col class="mt-4"><h3>الرجاء اختيار ملف</h3></v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-file-input
                  truncate-length="15"
                  label="اختر ملف"
                  show-size
                  accept=".csv"
                  v-model="file"
                ></v-file-input>
              </v-col>
            </v-row>
            <v-row>
              <v-col offset="9" cols="2">
                <v-btn
                  color="success"
                  @click="UploadFile"
                  rounded
                  :disabled="UnlockUpload"
                  >رفع</v-btn
                >
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-card>
          <v-toolbar color="red accent-2" dark>
            <v-toolbar-title> عرض الزبائن </v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-container>
            <v-row>
              <v-col cols="10" offset="1">
                <UsersTable />
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
    <v-snackbar
      transition="fade-transition"
      v-model="snackbar"
      :timeout="timeout"
      color="success"
    >
      تم انشاء الحساب بنجاح
    </v-snackbar>
    <v-snackbar
      transition="fade-transition"
      v-model="snackbar1"
      :timeout="timeout"
    >
      تم رفع الملف بنجاح
    </v-snackbar>
    <v-snackbar
      transition="fade-transition"
      v-model="snackbar2"
      color="error"
      :timeout="timeout"
    >
      رجاءاً قم بأختيار ملف
    </v-snackbar>
    <v-snackbar
      transition="fade-transition"
      v-model="snackbar3"
      color="error"
      :timeout="timeout"
    >
      عملية انشاء الحساب فشلت
    </v-snackbar>
    <v-snackbar
      transition="fade-transition"
      v-model="snackbar4"
      color="error"
      :timeout="timeout"
    >
      عملية الرفع فشلت
    </v-snackbar>
  </v-container>
</template>

<script>
import Axios from "axios";
import UsersTable from "../components/UsersTable";

export default {
  data() {
    return {
      CustId: "",
      Name: "",
      Username: "",
      Password: "",
      snackbar3: false,
      PasswordConfirm: "",
      snackbar: false,
      snackbar1: false,
      snackbar2: false,
      snackbar4: false,
      timeout: 2500,
      file: null,
      pwdRules: [
        (v) => !!v || "كلمة المرور مطلوبة",
        (v) => (v && v.length >= 6) || "ادنى حد لكلمة المرور هو 6",
      ],
      ReqRules: [(v) => !!v || "الحقل مطلوب"],
    };
  },
  created() {
    const baseURI = "https://erp.matein3.com/api/Customer/policy";
    this.$axios.get(baseURI).then((result) => {
      if (!result.data.data) {
        this.$router.push({ name: "home" });
      }
    });
  },
  computed: {
    UnlockUpload() {
      return this.file === null ? true : false;
    },
    NotEmptyFields() {
      return this.Password === this.PasswordConfirm &&
        this.Password !== "" &&
        this.PasswordConfirm !== ""
        ? false
        : true;
    },
    UnlockRegister() {
      return this.Password === this.PasswordConfirm &&
        this.Password !== "" &&
        this.PasswordConfirm !== ""
        ? false
        : true;
    },
    PasswordChange() {
      return this.Password !== "" ? true : false;
    },
  },
  methods: {
    async Register() {
      this.$axios
        .post("Customer/Register", {
          id: this.CustId,
          name: this.Name,
          username: this.Username,
          password: this.Password,
        })
        .then(({ data }) => {
          if (data.is_success) this.snackbar = true;
          else this.snackbar3 = true;
          this.FlushVariables();
        })
        .catch(({ message }) => (this.snackbar3 = true));
    },
    checkKeyDownAlphaNumeric(event) {
      if (event.key === "Backspace") {
      } else if (!/^[0-9]\d*$/.test(event.key)) {
        this.ignoredValue = event.key ? event.key : "";
        event.preventDefault();
      }
    },
    async FlushVariables() {
      this.CustId = "";
      this.Name = "";
      this.Username = "";
      this.Password = "";
      this.PasswordConfirm = "";
    },
    async FlushFile() {
      this.file = null;
    },
    async UploadFile() {
      if (this.file === null) {
        this.snackbar2 = true;
      } else {
        let formData = new FormData();
        formData.append("File", this.file);
        this.$axios
          .post("Item/Upload", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then(({ data }) => {
            this.snackbar1 = true;
            this.file = null;
          })
          .catch(({ message }) => (snackbar4 = true));
      }
    },
  },
  components: {
    UsersTable,
  },
};
</script>

<style>
</style>